import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const SELECTOR =
    '[data-map-suggestion-zone-preview]';

function parseBoundary(value) {
    try {
        const parsed = JSON.parse(
            value || '[]'
        );

        if (!Array.isArray(parsed)) {
            return [];
        }

        return parsed
            .map((point) => {
                const latitude =
                    Number.parseFloat(
                        point?.latitude
                    );

                const longitude =
                    Number.parseFloat(
                        point?.longitude
                    );

                if (
                    !Number.isFinite(latitude)
                    || !Number.isFinite(longitude)
                ) {
                    return null;
                }

                return [
                    latitude,
                    longitude,
                ];
            })
            .filter(Boolean);
    } catch {
        return [];
    }
}

function initializePreview(preview) {
    if (
        preview.dataset
            .mapSuggestionZonePreviewReady
        === 'true'
    ) {
        return;
    }

    const canvas = preview.querySelector(
        '[data-map-suggestion-zone-preview-canvas]'
    );

    const existingBoundary =
        parseBoundary(
            preview.dataset
                .existingBoundary
        );

    const suggestedBoundary =
        parseBoundary(
            preview.dataset
                .suggestedBoundary
        );

    if (
        !canvas
        || suggestedBoundary.length < 3
    ) {
        return;
    }

    preview.dataset
        .mapSuggestionZonePreviewReady =
            'true';

    const initialPoint =
        suggestedBoundary[0];

    const map = L.map(
        canvas,
        {
            zoomControl: true,
            scrollWheelZoom: false,
        }
    ).setView(
        initialPoint,
        17
    );

    L.tileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
            maxZoom: 20,
            attribution:
                '&copy; OpenStreetMap contributors',
        }
    ).addTo(map);

    const allPoints = [];

    if (existingBoundary.length >= 3) {
        L.polygon(
            existingBoundary,
            {
                color: '#71717a',
                weight: 2,
                dashArray: '7 5',
                fillColor: '#a1a1aa',
                fillOpacity: 0.08,
            }
        )
            .addTo(map)
            .bindTooltip(
                'Current official boundary'
            );

        allPoints.push(
            ...existingBoundary
        );
    }

    L.polygon(
        suggestedBoundary,
        {
            color: '#0f766e',
            weight: 3,
            fillColor: '#14b8a6',
            fillOpacity: 0.22,
        }
    )
        .addTo(map)
        .bindTooltip(
            'Suggested boundary'
        );

    allPoints.push(
        ...suggestedBoundary
    );

    const bounds =
        L.latLngBounds(
            allPoints
        );

    if (bounds.isValid()) {
        map.fitBounds(
            bounds,
            {
                padding: [30, 30],
                maxZoom: 18,
                animate: false,
            }
        );
    }

    window.setTimeout(
        () => map.invalidateSize(),
        100
    );
}

function initializePreviews() {
    document
        .querySelectorAll(SELECTOR)
        .forEach(initializePreview);
}

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        initializePreviews,
        {
            once: true,
        }
    );
} else {
    initializePreviews();
}

document.addEventListener(
    'livewire:navigated',
    initializePreviews
);
